import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@mui/material";
import React from "react";
import MDButton from "../../../Components/MDButton";
import { ErrorToaast, SuccessToaast } from "../../../utils/toast/Toast";
import { BillModel } from "../../../Api/Models/bill";

interface IDeleteRows {
  open: boolean;
  setClose: any;
  onDone: any;
  id: number;
}

export default function DeleteDialog(props: IDeleteRows) {
  const model = new BillModel();
  function handleDelete() {
    model
      .Delete(props.id)
      .then((r) => {
        SuccessToaast("قبض با موفقیت حذف شد");
        props.onDone();
      })
      .catch((e) => ErrorToaast(e || "خطا در برقراری ارتباط"));
  }
  return (
    <Dialog open={props.open} onClose={props.setClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">آیا از حذف قبض مورد نظر اطمینان دارید؟</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          با حذف قبض مورد نظر اطلاعات آن پاک خواهد شد، آیا از انجام این کار اطمینان دارید؟
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <MDButton color="success" onClick={handleDelete}>
          حذف
        </MDButton>
        <MDButton onClick={props.setClose} autoFocus color="warning">
          بازگشت
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
